import { NgModule }                        from '@angular/core';
import { LoginComponent }                  from './login.component';
import { MatButtonModule, MatInputModule } from '@angular/material';
import { SharedModule }                    from '../shared/shared.module';
import { LoginGuard } from './login.guard';

@NgModule({
  imports: [
    SharedModule,
    MatButtonModule,
    MatInputModule
  ],
  declarations: [LoginComponent],
  exports: [LoginComponent],
  providers: [LoginGuard]
})
export class LoginModule { }
